import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=5749f881"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5749f881')) {
      api.createRecord('5749f881', component.options)
    } else {
      api.reload('5749f881', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=5749f881", function () {
      api.rerender('5749f881', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/Table.vue"
export default component.exports